import { Box, Button, Card, CardHeader, Divider, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { CreateIssueModal, MaterialSymbolIcon, MaterialSymbols, ViewToggleButtonGroup } from "src/components";
import { useBreakpoints, useSession } from "src/hooks";
import { UserIssuesList } from "src/pages/UserPages/UserImplementationPage/components";
import { UserIssuesFilterButton } from "src/pages/UserPages/UserImplementationPage/components/UserIssuesFilterButton";
import { useUserImplementationSettings } from "src/pages/UserPages/UserImplementationPage/hooks";

interface Props {
  userGuid: string;
}

const UserLoopsAgendaStep = (props: Props) => {
  const { userId: sessionUserGuid } = useSession();
  const { isMdUp } = useBreakpoints();
  const { settings, updateSettings } = useUserImplementationSettings(props.userGuid);
  const [isTableView, setIsTableView] = useState(true);
  const [isCreateIssueModalOpen, setIsCreateIssueModalOpen] = useState(false);

  useEffect(() => {
    handleViewToggled(settings.tableView);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.userGuid]);

  useEffect(() => {
    if (isMdUp) {
      setIsTableView(settings.tableView);
    } else {
      setIsTableView(false);
    }
  }, [isMdUp, props.userGuid, settings]);

  function handleViewToggled(value: boolean) {
    setIsTableView(value);
    updateSettings({
      tableView: value,
    });
  }

  return (
    <>
      <Card>
        <CardHeader
          direction="row"
          title={<Typography variant="h6">Loops</Typography>}
          action={
            <Stack direction="row" spacing={1} divider={<Divider orientation="vertical" flexItem />}>
              {props.userGuid === sessionUserGuid && (
                <Button
                  variant="tertiary"
                  startIcon={<MaterialSymbolIcon symbol={MaterialSymbols.QuickPhrases} />}
                  onClick={() => setIsCreateIssueModalOpen(true)}
                >
                  Add New Loop
                </Button>
              )}

              <Stack direction="row" spacing={1}>
                <UserIssuesFilterButton userGuid={props.userGuid} />
                {isMdUp && (
                  <ViewToggleButtonGroup
                    variant="tertiary"
                    isTableView={isTableView}
                    onViewToggled={handleViewToggled}
                    fontSize="small"
                  />
                )}
              </Stack>
            </Stack>
          }
          sx={{ pb: 0, pr: 0.5 }}
        />
        <Box sx={{ p: 0.5 }}>
          <UserIssuesList userGuid={props.userGuid} isTableView={isTableView} />
        </Box>
      </Card>

      <CreateIssueModal
        visible={isCreateIssueModalOpen}
        onCreated={() => setIsCreateIssueModalOpen(false)}
        onCancelled={() => setIsCreateIssueModalOpen(false)}
      />
    </>
  );
};

export { UserLoopsAgendaStep };
